// 30 frames per second
export const fps30 = 30;
